import LockConsumer from './LockConsumer';
export default LockConsumer;
